<template>
    <UApp>
        <UDashboardGroup data-theme="light" class="z-0 h-[100dvh] overflow-x-hidden" storage-key="global-chat">
            <UDashboardPanel id="main" :resizable="globalChat.isOpen.value" :default-size="70" :min-size="40" :max-size="80"
                class="overflow-y-auto overflow-x-hidden" :class="{ 'lg:w-full!': !globalChat.isOpen.value }">
                <SharedAlerts>
                    <NuxtPage />
                </SharedAlerts>
            </UDashboardPanel>
            <UDashboardPanel v-if="globalChat.isOpen.value" id="chat" class="bg-white"
                :class="{ 'max-lg:fixed max-lg:inset-0 max-lg:z-50 max-lg:w-full!': route.path.startsWith('/campaigns/edit/') }">
                <SharedGlobalChatPanel />
            </UDashboardPanel>
        </UDashboardGroup>
        <NuxtLoadingIndicator :throttle="200" color="rgb(29 78 216)" />
    </UApp>
</template>

<script setup lang="ts">
useHead({
    link: [
        { rel: 'icon', type: 'image/x-icon', href: '/img/favicon.ico' }
    ]
})
useResearchResultWatcher();
useICPHooksProvider();
const globalChat = useGlobalChat();
const route = useRoute();
</script>

<style>
mark {
    color: transparent;
    background-color: rgb(191 219 254);
}

em {
    color: rgb(29 78 216);
}

.tiptap :first-child {
    margin-top: 0;
}

/* List styles */
.tiptap ul,
.tiptap ol {
    padding: 0 1rem;
    margin: 1.25rem 1rem 1.25rem 0.4rem;
}

.tiptap ul li p,
.tiptap ol li p {
    margin-top: 0.25em;
    margin-bottom: 0.25em;
}

.tiptap div.is-editor-empty:first-child::before {
    color: rgb(148 163 184);
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
}

.tiptap a {
    text-decoration-line: underline;
    text-decoration-color: rgb(59 130 246);
    color: rgb(59 130 246);
    cursor: pointer;
}
</style>
